import { observer } from 'mobx-react';
import Counter1_0 from './Counter1_0';
import Counter1_1 from './Counter1_1';
import { emptyFragment } from '../../../../../../../../EmptyFragment';

interface Props {
  utilized: number;
}

function OneOfferingType({ utilized }: Props) {
  switch (utilized) {
    case 0:
      return <Counter1_0 />;
    case 1:
      return <Counter1_1 />;
    default:
      return emptyFragment();
  }
}

export default observer(OneOfferingType);
